import { Modal, Button } from "react-bootstrap";

const AIDWModal = ({ showAIDWModal, setAIDWShowModal, handleConfirmDeleteAIDW, deleteAIDWData,setDeleteGoalId }) => {

  const handleCloseAIDWModal = () => {
    setAIDWShowModal(false);
  };
  

  return (
    <>
      <Modal show={showAIDWModal} onHide={handleCloseAIDWModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="fs-5" >Are you sure you want to delete the Additional sources of income: <span className="fw-bold clrgreen " >
            {deleteAIDWData}
             </span> ?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseAIDWModal}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirmDeleteAIDW}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AIDWModal;
